export function randomString(e) {
    e = e || 16;
    let t = "abcdefhijkmnprstwxyz2345678",
        a = t.length,
        n = "";
    for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
    return n
}

export function genCounter(len,duration){
    len=Math.max(parseInt(len),0)||5
    duration=Math.max(parseInt(duration),0)||5
    let arr=new Array(len).fill(new Date(0))
    let idx=0
    return {
        add(){
            arr[(idx++)%len]=new Date()
        },
        ok(){
            return new Date()-arr[(idx+1)%len]<duration*1000
        }
    }
}